import React from "react";
import Navbar from "../../../navbar";
import Footer from "../../../footer";
import "./style.scss";
// import IpLocation from "ip-location";
// import axios from "axios";
import SEO from "../../../seo";

import { Link } from "gatsby";

import blogData from "../../../bloginner/data";

// import banner from "../../../../images/memoryfoamvslatexfoam.png";

export default function HowOften(props) {
  const { location, data } = props;

  //   const { blogImg, blogTitle, content, date, seoDescription, seoImg } = data;

  var prev = null;
  var next = null;

  let i = 0;

  blogData.forEach((item, it) => {
    if (location.pathname.includes(item.link)) {
      i = it;
    }
  });

  if (i === 0) {
    prev = null;
  } else {
    prev = (
      <Link className="blog__bottombuttons__prev" to={blogData[i - 1].link}>
        <i class="fas fa-arrow-left"></i> Prev
      </Link>
    );
  }

  if (i === blogData.length - 1) {
    next = null;
  } else {
    next = (
      <Link className="blog__bottombuttons__next" to={blogData[i + 1].link}>
        Next <i class="fas fa-arrow-right"></i>
      </Link>
    );
  }

  return (
    <div className="blog howoften">
      <SEO
        title={
          "How Often Should You Replade Your Mattress | Eclipse International"
        }
        description={""}
        img={""}
      />
      <Navbar />
      <div className="blog__content">
        <h1 className="blog__title">
          How Often Should You Replace Your Mattress
        </h1>
        <div className="blog__header">
          <div className="blog__header__date">August 17, 2022</div>
          <div className="blog__header__socialshare">
            Share&nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </div>
        <img
          className="blog__headerimg blog__headerimg--desktop"
          src={
            "https://eclipsemattress.in/assets/blog/how-often-banner.jpg"
          }
          alt="Blog Header Image"
        ></img>
        <img
          className="blog__headerimg blog__headerimg--mobile"
          src={
            "https://eclipsemattress.in/assets/blog/how-often-banner.jpg"
          }
          alt="Blog Header Image"
        ></img>

        <div className="blog__container">
          <p>
            On an average mattresses last for about 10 years, but this number
            can vary depending on your mattress type. Coming to the lifecycle of
            mattresses, here’s how often you should replace your them, based on
            the type of mattress you own:
            <br />
          </p>
          <div className="row">
            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon1.jpg"></img>
                <div>
                  <h4>Innerspring Mattress</h4>
                  <p>
                    8 Years
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon2.jpg"></img>
                <div>
                  <h4>Memory Foam Mattress</h4>
                  <p>
                    10 Years
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon3.jpg"></img>
                <div>
                  <h4>Hybrid Mattress</h4>
                  <p>
                    10 Years
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon4.jpg"></img>
                <div>
                  <h4>Water Bed</h4>
                  <p>
                    2 to 15 years
                  </p>
                </div>
              </div>
            </div>

            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon5.jpg"></img>
                <div>
                  <h4>Gel Foam Mattress</h4>
                  <p>
                    10 to 15 years
                  </p>
                </div>
              </div>
            </div>
            <div className="col col-12 col-xl-6">
              <div className="howoften__card">
                <img src="https://eclipsemattress.in/assets/blog/how-often-icon6.jpg"></img>
                <div>
                  <h4>Latex Foam Mattress</h4>
                  <p>
                    15 years
                  </p>
                </div>
              </div>
            </div>
          </div>

          <br />
          <br />
        </div>

        <center>
          <div className="blog__header__socialshare">
            Share &nbsp; &nbsp;
            <span className="hicon">
              <a
                href={`https://www.facebook.com/sharer/sharer.php?u=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-facebook-f"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://twitter.com/intent/tweet?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-twitter"></i>
              </a>
            </span>
            <span className="hicon">
              <a
                href={`https://www.linkedin.com/sharing/share-offsite/?url=https://eclipsemattress.in${location.pathname}`}
                target="_blank"
                className=""
              >
                <i class="fab fa-linkedin-in"></i>
              </a>
            </span>
          </div>
        </center>

        <div className="blog__bottombuttons">
          {prev} {next}
        </div>
      </div>
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
}
